var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3602 6.5C22.4402 7.55 21.0502 8.04 19.6902 8.35C17.7902 8.79 15.6602 9.11 14.2302 10.58C13.1002 11.74 12.5902 13.35 12.3402 14.91C12.2802 15.29 12.2302 15.67 12.2002 16.05C13.3102 13.18 16.3902 11 19.5602 10.53C16.2102 11.66 13.3902 14.26 11.9902 17.5C13.3702 16.41 15.1902 16.07 16.9302 15.75C18.6602 15.42 20.4802 15.02 21.7902 13.83C22.7602 12.95 23.3502 11.69 23.5702 10.4C23.7902 9.11 23.6602 7.78 23.3602 6.5Z",
    fill: "#6EBD44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.640428 6.5C1.56043 7.55 2.95043 8.04 4.31043 8.35C6.21043 8.79 8.34043 9.11 9.77043 10.58C10.9004 11.74 11.4104 13.35 11.6604 14.91C11.7204 15.29 11.7704 15.67 11.8004 16.05C10.6904 13.18 7.61043 11 4.44043 10.53C7.79043 11.66 10.6104 14.26 12.0104 17.5C10.6304 16.41 8.81043 16.07 7.07043 15.75C5.34043 15.42 3.52043 15.02 2.21043 13.83C1.24043 12.95 0.650428 11.69 0.430428 10.4C0.210428 9.11 0.340428 7.78 0.640428 6.5Z",
    fill: "#6EBD44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.e062cf380dc8c2bfa0ce7d3b98f8c01d.svg";
export { ForwardRef as ReactComponent };